import React, {Fragment} from "react";
import LoadingSpinnerComponent from "./LoadingSpinnerComponent";
import ImageViewComponent from "./ImageViewComponent";
import S3DocumentUploadService from "../services/S3DocumentUploadService";


export default class S3ViewComponent extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            src: this.props.src
        }
    }

    componentDidMount() {
        if (this.state.src === undefined) {
            S3DocumentUploadService.retrieveS3DocumentWithUrl(this.props.metaDataId).then(response => {
                if (response.presignedUrl) {
                    this.setState({
                        src: response.presignedUrl
                    });
                }
            })
        }
    }

    onImageLoaded(){
        if(this.props.onImageLoaded){
            this.props.onImageLoaded();
        }
    }
    render() {

        if (this.state.src === undefined)
            return <LoadingSpinnerComponent/>;

        return <Fragment>
            <ImageViewComponent
                style={{
                    maxWidth: "200px",
                    maxHeight: "200px"
                }}
                src={this.state.src}
                onImageLoaded={this.onImageLoaded.bind(this)}
            />
        </Fragment>
    }
}
